<template>
  <div
    v-if="store.isSimulationForDifferentLoanAmounts || store.isSimulationForDifferentLoanPeriods"
    class="pa-3 different-values-info bb d-flex align-sm-center justify-space-between flex-column flex-sm-row"
  >
    <p class="primary--text d-flex mb-0">
      <v-icon v-if="$vuetify.breakpoint.smAndUp" class="mr-1 primary--text">mdi-information</v-icon>
      <span class="different-values-info__text">
        <template v-if="store.isSimulationForDifferentLoanAmounts && store.isSimulationForDifferentLoanPeriods">
          <span v-html-safe="I18NGetter().useSimulationDifferentValuesInfo.SIMULATION_BOTH"></span>
        </template>
        <template v-else-if="store.isSimulationForDifferentLoanAmounts">
          <span v-html-safe="I18NGetter().useSimulationDifferentValuesInfo.SIMULATION_LOAN_AMOUNT"></span>
        </template>
        <template v-else-if="store.isSimulationForDifferentLoanPeriods">
          <span v-html-safe="I18NGetter().useSimulationDifferentValuesInfo.SIMULATION_LOAN_PERIOD"></span>
        </template>
      </span>
    </p>
    <div>
      <v-btn v-if="store.isSimulationForDifferentLoanAmounts" @click="store.removeCustomLoanAmounts()" outlined
             class="mr-2">
        <v-icon left v-if="$vuetify.breakpoint.mdAndUp">mdi-refresh</v-icon>
        {{ I18NGetter().useSimulationDifferentValuesInfo.RESTORE_AMOUNT }}
        <span v-if="$vuetify.breakpoint.mdAndUp">{{I18NGetter().useSimulationDifferentValuesInfo.LOAN}}</span>
      </v-btn>
      <v-btn v-if="store.isSimulationForDifferentLoanPeriods" @click="store.removeCustomLoanPeriods()" outlined>
        <v-icon left v-if="$vuetify.breakpoint.mdAndUp">mdi-refresh</v-icon>
        {{ I18NGetter().useSimulationDifferentValuesInfo.RESTORE_PERIOD }}
        <span v-if="$vuetify.breakpoint.mdAndUp">{{ I18NGetter().useSimulationDifferentValuesInfo.LOAN }}</span>
      </v-btn>
    </div>
  </div>
</template>
<script lang="ts" setup>
import {useSimulationStore} from '@/components/calculator/services/SimulationStore';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';

const store = useSimulationStore();
</script>
<style lang="scss" scoped>
.different-values-info {
  height: 57px;

  @media screen and (max-width: 600px) {
    height: 112px;
  }

  &__text {
    @media screen and (max-width: 600px) {
      font-size: 14px;
    }
  }
}
</style>
